
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='modal__video'>\r\n<div id=\"ytplayer\"></div>\r\n</div>";
},"useData":true});
                export default templateFunction;
                